import React from 'react';
import { Form, Alert, Table } from 'react-bootstrap';
import { calculateMarginPrice, resolveProductPricing } from '../utils/productPricing.mjs';

export default function ProductPricingFields({ value, onChange, deferCostError = false }) {
  const marginMode = value.pricingMethod === 'margin';
  const hasCost = value.costPrice != null && String(value.costPrice).trim() !== '';
  let preview;
  let error;
  if (marginMode) {
    try { preview = resolveProductPricing(value); } catch (e) { error = e.message; }
  }
  const updateVariant = (field, index, patch) => onChange({
    [field]: (value[field] || []).map((v, i) => i === index ? { ...v, ...patch } : v),
  });
  return <section aria-label='Product pricing' className='my-3'>
    <Form.Group controlId='pricingMethod'>
      <Form.Label>Pricing method</Form.Label>
      <Form.Control as='select' value={value.pricingMethod || 'manual'} onChange={e => onChange({ pricingMethod: e.target.value })}>
        <option value='manual'>Manual price</option><option value='margin'>Profit margin</option>
      </Form.Control>
    </Form.Group>
    {marginMode && <>
      <Form.Group controlId='costPrice'>
        <Form.Label>Cost ($)</Form.Label>
        <Form.Control type='number' min='0.01' max='999999.99' step='any' value={value.costPrice ?? ''} onChange={e => onChange({ costPrice: e.target.value, costSource: 'admin' })} />
        <Form.Text>Enter or confirm your cost, including the expenses you want covered. Supplier API costs are preserved before markup. Other imports require a confirmed cost.</Form.Text>
      </Form.Group>
      <Form.Group controlId='profitMargin'>
        <Form.Label>Profit margin (%)</Form.Label>
        <Form.Control type='number' min='0' max='99.9999' step='any' value={value.profitMargin ?? ''} onChange={e => onChange({ profitMargin: e.target.value })} />
        <Form.Text>Selling price = cost ÷ (1 − margin / 100), rounded to the nearest cent. Maximum selling price: $999,999.99.</Form.Text>
      </Form.Group>
      {['skus', 'colorsVariants'].map(field => (value[field] || []).length > 0 && <Table responsive key={field}>
        <thead><tr><th>{field === 'skus' ? 'SKU' : 'Legacy variant'}</th><th>Use base price</th><th>Cost ($)</th><th>Selling price</th></tr></thead>
        <tbody>{value[field].map((v, index) => {
          const label = `${field} ${index + 1}`;
          const useBase = v.useBasePrice === true || (v.costPrice == null && (v.price == null || v.price === ''));
          let amount = 'Enter valid cost and margin';
          try { amount = '$' + calculateMarginPrice(useBase ? value.costPrice : v.costPrice, value.profitMargin).toFixed(2); } catch (_) {}
          return <tr key={index}><td>{v.name || Object.values(v.key || {}).join(' / ') || label}</td>
            <td><Form.Check aria-label={`${label} use base price`} checked={useBase} onChange={e => updateVariant(field, index, { useBasePrice: e.target.checked, ...(e.target.checked ? { costPrice: undefined, price: undefined } : { costPrice: '' }) })} /></td>
            <td><Form.Control aria-label={`${label} cost`} type='number' step='any' min='0.01' disabled={useBase} value={v.costPrice ?? ''} onChange={e => updateVariant(field, index, { costPrice: e.target.value, useBasePrice: false })} /></td>
            <td>{amount}</td></tr>;
        })}</tbody>
      </Table>)}
      {error && (!deferCostError || hasCost) ? <Alert variant='danger' role='alert'>{error}</Alert> : preview ? <p role='status'>${Number(value.costPrice).toFixed(2)} cost · {value.profitMargin}% margin · ${preview.price.toFixed(2)} selling price.</p> : null}
    </>}
  </section>;
}
